function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function ResultImage({ result, children }) {
  return (
    <div className="relative w-full h-full overflow-hidden border-0">
      {result?.images?.length > 2 ? (
        <>
          <img
            className="absolute inset-0 object-cover w-full h-full bg-[--section-background-color,theme(colors.brand.white)]"
            srcSet={generateSrcSet(result.images[1].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[1].alt}
          />
          <img
            className="absolute inset-0 object-cover w-full h-full transition-all bg-[--section-background-color,theme(colors.brand.white)] group-hover/card:opacity-0"
            srcSet={generateSrcSet(result.images[0].src, IMAGE_WIDTHS)}
            sizes="50vw"
            alt={result.images[0].alt}
          />
        </>
      ) : result.image ? (
        <img alt={result.name} className="object-cover w-full h-full bg-[--section-background-color,theme(colors.brand.white)] object-fit" src={result.image} srcSet={generateSrcSet(result.image, IMAGE_WIDTHS)}/>
      ) : null}
      {children}
    </div>
  )
}
